export default {
    en:{
        messages:{
            frequent_questions:"Frequent Questions",
            recommendations: "Recommendations",
            about_us: "About us",
            // Company Information Section
            company_info_title: "Learn more about Emanta",
            company_info_subtitle: "All the information you need about our company.",
            what_is_emanta_title: "What is Emanta?",
            what_is_emanta_content: "Emanta is a travel tech startup born in Costa Rica. It is a digital concierge platform that allows hotels and property hosts to create and manage personalized itineraries in minutes, connecting in real time with validated local providers. At the same time, it helps service providers and experience creators reach travelers who have already booked their stay in the country, thus increasing guest motivation to enjoy activities. It works as a progressive web application (PWA), which guarantees easy access from mobile, tablet or computer, without the need for complex downloads or installations, with the option to add it directly to the home screen. Emanta is developed under the Lean Startup approach, which ensures constant evolution thanks to continuous improvements based on the use and feedback from our customers.",
            how_platform_works_title: "How does our platform work?",
            how_platform_works_content: "Emanta connects concierges, property hosts and hotels with local providers directly and in real time. Each service or experience provider updates their availability on the platform, and the concierge can view it instantly, select services, define dates and times according to guest needs. Additionally, the platform allows direct contact between the concierge and the provider, facilitating clarifying details, personalizing experiences and ensuring smooth coordination. Emanta integrates artificial intelligence tools that not only recommend activities, but also automate key processes such as reminders, availability validations and itinerary adjustments, reducing administrative burden and increasing efficiency.",
            cancellation_policy_title: "Cancellation and Refund Policy?",
            cancellation_policy_content: "Cancellation requests that comply with the provider's policies will be managed directly with them. If approved, Emanta will process the refund to the same payment method used in the purchase.",
            security_privacy_title: "Security and Privacy",
            security_privacy_content: "We protect your data with international security standards and only work with validated providers to guarantee reliable experiences.",
            customer_support_title: "Customer Support",
            customer_support_content: "We provide assistance Monday to Friday in Spanish and English for hotels, hosts and providers, resolving doubts or incidents in real time.",
            global_coverage_title: "Global Coverage",
            global_coverage_content: "Emanta was born in Costa Rica, one of the most recognized tourist destinations in the world. We currently operate with local providers and are expanding to new international markets.",
            roadmap_title: "Roadmap",
            roadmap_content: "At Emanta we are always one step ahead. Very soon we will bring: November 2025: a renewed chat for providers and concierges to communicate more agilely and directly. December 2025: the incorporation of 50 new local services, expanding options to surprise each guest. January 2026: the arrival of advanced artificial intelligence to automate processes and create smarter and more personalized itineraries."
        },
        common: {
            contact: "Contact us",
            request_demo: "Request a demo",
            commissions: "commissions"
        },
        welcome_section: {
            subtitle: "Emanta connects you with trusted providers to create itineraries in minutes, automate bookings, and earn commissions on every sale. A powerful and easy-to-use platform that elevates your clients' experience and grows your business hassle-free.",
            itineraries: "itineraries",
            first_title_part: " Connect with service providers, create",
            second_title_part: " with just a few clicks and earn ",
            third_title_part: "for every booking.",
            widget: {
                title: "Concierge Portal Simulator",
                subtitle: "Select excursions & estimate your commissions",
                commission_balance: "Commission Balance",
                guests: "Number of guests",
                add_to_itinerary: "Add to Itinerary",
                added: "Added",
                active_itinerary: "Active Itinerary",
                empty_itinerary: "Select an activity to begin building the itinerary",
                total_commission: "Total Commission",
                estimated_payout: "Estimated Payout",
                activities: {
                    activity_1: {
                        name: "Manuel Antonio Guided Tour",
                        price: "$65/guest",
                        commission: "15% commission ($9.75)"
                    },
                    activity_2: {
                        name: "Arenal Hike & Hot Springs",
                        price: "$90/guest",
                        commission: "15% commission ($13.50)"
                    },
                    activity_3: {
                        name: "Catamaran Sunset Cruise",
                        price: "$85/guest",
                        commission: "15% commission ($12.75)"
                    }
                }
            }
        },
        features_section: {
            title: 'More experiences, less hassle',
            subtitle: "Emanta centralizes your tourism operation so you can focus on what matters: your customers.",
            features: {
                feature_1: {
                    title: "Time Optimization",
                    description: "Centralizes itinerary and booking management on a real-time platform, reducing the operational burden of hotels, concierges, and providers."
                },
                feature_2: {
                    title: "Personalized Experiences",
                    description: "Allows guests to book activities and services tailored to their tastes, ensuring unique and memorable experiences."
                },
                feature_3: {
                    title: "Guaranteed Quality",
                    description: "Access to verified and evaluated providers, ensuring that each service meets the highest standards."
                },
                feature_4: {
                    title: "Increased Revenue and Visibility",
                    description: "Generates commission opportunities for hotels and greater exposure for providers, boosting bookings and sales with no additional effort."
                },
                feature_5: {
                    title: "Satisfaction Measurement",
                    description: "Collects feedback from guests and customers to continuously improve service and strengthen loyalty."
                },
                feature_6: {
                    title: "Automated and Secure Payments",
                    description: "Manages collections and payments automatically and reliably, simplifying transactions for all involved."
                }
            }
        },
        how_it_works: {
            title: "How it works ",
            subtitle: "Three simple steps to create the perfect itinerary",
            steps: {
                step_1: {
                    title: "Choose the service you need",
                    description: "Select the different services you want to hire from our verified network of providers"
                },
                step_2: {
                    title: "Book for your clients",
                    description: "Improve the experience, increase productivity and reduce your clients' waiting time when making itineraries for them."
                },
                step_3: {
                    title: "Earn commissions on sales",
                    description: "Earn 100% of the commissions for each booking or itinerary sold through Emanta."
                }
            }
        },
        plans_section: {
            title: "Plans that adapt to you",
            subtitle: "Choose the perfect plan for your needs",
            more_popular: "More popular",
            start_free: "Start Free",
            footer_note: " You can have a free 3-day trial • No commitment • Cancel anytime",
            monthly: "Monthly",
            yearly: "Yearly",
            save_20: "Save 20%",
            billed_annually: "billed annually",
            plans: {
                plan_1: {
                    title: "Experience Creator",
                    description: "Ideal for experience and service creators.",
                    price: "2% commission per sale",
                    feature_1: "Upload all the services you want without limit.",
                    feature_2: "Access to update availability in real time.",
                    feature_3: "Receive evaluations and comments from clients.",
                },
                plan_2: {
                    title: "Concierge",
                    description: "Optimize booking and provider management.",
                    price: "$80 + Taxes",
                    feature_1: "Connect with verified providers.",
                    feature_2: "Get priority support for your bookings.",
                    feature_3: "Earn commissions for each sale made.",
                },
                plan_3: {
                    title: "Experience creator + Concierge",
                    description: "The most complete solution to maximize income.",
                    price: "$95 + Taxes",
                    feature_1: "Offer experiences and connect with providers in a single plan.",
                    feature_2: "Double your opportunities to generate income.",
                    feature_3: "Access advanced collaboration features.",
                },
                plan_4: {
                    title: "Enterprise",
                    description: "Designed for companies with multiple concierges.",
                    price: "Custom",
                    feature_1: "Customize the itinerary design with your branding.",
                    feature_2: "Add the number of users you need.",
                    feature_3: "Select the most relevant services for your organization.",
                },

            }
        },
        cta_section: {
            title: "Ready to transform your business?",
            subtitle: "Start using Emanta today and take your service to the next level.",
            button_text: "Request a demo",
            without_commitment: "No commitment",
            support: "24/7 Support",
            footer_note: " You can have a free 3-day trial  ",
            email_placeholder: "Your email",
            sending: "Sending...",
            success_message: "Thank you! We will contact you soon to schedule your demo.",
            error_message: "There was an error sending your request. Please try again.",
            invalid_email: "Please enter a valid email address."
        },
        chatbot: {
            title: "Emanta Assistant",
            subtitle_welcome: "We are here to help you with any question about the platform",
            subtitle_online: "Online",
            welcome_message: "Hi! I'm Emanta's virtual assistant. How can I help you today?",
            input_placeholder: "Write your question...",
            quick_actions_label: "Quick actions:",
            footer_available: "Team available 24/7",
            aria_open_chat: "Open chat",
            aria_close_chat: "Close chat",
            aria_send_message: "Send message",
            quick_action_itinerary: "How to create an itinerary?",
            quick_action_providers: "Manage providers",
            quick_action_commissions: "Configure commissions",
        },
        notifications: {
            fallback_body: "New activity in Emanta.",
            events: {
                conversation_message_created: {
                    title: "New message",
                    body: "{messagePreview}",
                },
                booking_created: {
                    title: "Booking created",
                    body: "{serviceName} was booked for itinerary {itineraryCode}.",
                },
                booking_updated: {
                    title: "Booking updated",
                    body: "{serviceName} was updated for itinerary {itineraryCode}.",
                },
                booking_cancelled: {
                    title: "Booking cancelled",
                    body: "{serviceName} was cancelled for itinerary {itineraryCode}.",
                },
                itinerary_approval_requested: {
                    title: "Approval request sent",
                    body: "The approval request for itinerary {itineraryCode} was sent to {customerName}.",
                },
                itinerary_approved: {
                    title: "Itinerary approved",
                    body: "{customerName} approved itinerary {itineraryCode}.",
                },
                itinerary_rejected: {
                    title: "Itinerary rejected",
                    body: "{customerName} rejected itinerary {itineraryCode}.",
                },
                itinerary_payment_requested: {
                    title: "Payment requested",
                    body: "Payment instructions were sent for itinerary {itineraryCode}.",
                },
                itinerary_payment_confirmed: {
                    title: "Payment confirmed",
                    body: "Payment was confirmed for itinerary {itineraryCode}.",
                },
                itinerary_updated_after_payment: {
                    title: "Paid itinerary updated",
                    body: "An update was sent for itinerary {itineraryCode}.",
                },
            },
        }
    },
    es:{
        messages:{
            frequent_questions:"Preguntas Frecuentes",
            recommendations: "Recomendaciones",
            about_us: "Acerca de nosotros",
            // Company Information Section
            company_info_title: "Conoce más sobre Emanta",
            company_info_subtitle: "Toda la información que necesitas sobre nuestra empresa.",
            what_is_emanta_title: "¿Qué es Emanta?",
            what_is_emanta_content: "Emanta es una startup de travel tech nacida en Costa Rica. Es una plataforma de concierge digital que permite a hoteles y property hosts crear y gestionar itinerarios personalizados en minutos, conectando en tiempo real con proveedores locales validados. Al mismo tiempo, ayuda a los proveedores de servicios y creadores de experiencias a llegar a viajeros que ya han reservado su estadía en el país, aumentando así la motivación de los huéspedes para disfrutar actividades. Funciona como una aplicación web progresiva (PWA), lo que garantiza un acceso fácil desde móvil, tablet o computadora, sin necesidad de descargas ni instalaciones complejas, con la opción de añadirla directamente a la pantalla de inicio. Emanta está desarrollada bajo el enfoque Lean Startup, lo que asegura una evolución constante gracias a mejoras continuas basadas en el uso y la retroalimentación de nuestros clientes.",
            how_platform_works_title: "¿Cómo funciona nuestra plataforma?",
            how_platform_works_content: "Emanta conecta a concierges, property hosts y hoteles con proveedores locales de manera directa y en tiempo real. Cada proveedor de servicios o experiencias actualiza su disponibilidad en la plataforma, y el concierge puede visualizarla al instante, seleccionar servicios, definir fechas y horarios de acuerdo con las necesidades del huésped. Además, la plataforma permite contacto directo entre el concierge y el proveedor, facilitando aclarar detalles, personalizar experiencias y garantizar una coordinación fluida. Emanta integra herramientas de inteligencia artificial que no solo recomiendan actividades, sino que también automatizan procesos clave como recordatorios, validaciones de disponibilidad y ajustes en itinerarios, reduciendo la carga administrativa y aumentando la eficiencia.",
            cancellation_policy_title: "¿Política de Cancelación y Reembolsos?",
            cancellation_policy_content: "Las solicitudes de cancelación que cumplan con las políticas del proveedor serán gestionadas directamente con él. En caso de ser aprobadas, Emanta procesará la devolución al mismo medio de pago utilizado en la compra.",
            security_privacy_title: "Seguridad y Privacidad",
            security_privacy_content: "Protegemos tus datos con estándares internacionales de seguridad y solo trabajamos con proveedores validados para garantizar experiencias confiables.",
            customer_support_title: "Soporte al Cliente",
            customer_support_content: "Brindamos asistencia de Lunes a Viernes en español e inglés para hoteles, hosts y proveedores, resolviendo dudas o incidencias en tiempo real.",
            global_coverage_title: "Cobertura global",
            global_coverage_content: "Emanta nace en Costa Rica, uno de los destinos turísticos más reconocidos del mundo. Actualmente operamos con proveedores locales y estamos en expansión hacia nuevos mercados internacionales.",
            roadmap_title: "Roadmap",
            roadmap_content: "En Emanta siempre estamos un paso adelante. Muy pronto traeremos: Noviembre 2025: un chat renovado para que proveedores y concierges se comuniquen de forma más ágil y directa. Diciembre 2025: la incorporación de 50 nuevos servicios locales, ampliando las opciones para sorprender a cada huésped. Enero 2026: la llegada de inteligencia artificial avanzada para automatizar procesos y crear itinerarios más inteligentes y personalizados."
        },
        common: {
            contact: "Contáctenos",
            request_demo: "Solicitar una demo",
            commissions: "comisiones"
        },
        welcome_section: {
            subtitle: "Emanta te conecta con proveedores de confianza para crear itinerarios en minutos, automatizar reservas y ganar comisiones por cada venta. Una plataforma potente y fácil de usar que eleva la experiencia de tus clientes y hace crecer tu negocio sin complicaciones.",
            itineraries: "itinerarios",
            first_title_part: " Conecta con proveedores de servicios, crea",
            second_title_part: " con unos pocos clicks y gana ",
            third_title_part: "por cada reserva.",
            widget: {
                title: "Simulador de Portal Concierge",
                subtitle: "Selecciona excursiones y estima tus comisiones",
                commission_balance: "Balance de Comisiones",
                guests: "Número de huéspedes",
                add_to_itinerary: "Agregar a Itinerario",
                added: "Agregado",
                active_itinerary: "Itinerario Activo",
                empty_itinerary: "Selecciona una actividad para comenzar a crear el itinerario",
                total_commission: "Comisión Total",
                estimated_payout: "Pago Estimado",
                activities: {
                    activity_1: {
                        name: "Tour Guiado Manuel Antonio",
                        price: "$65/huésped",
                        commission: "15% comisión ($9.75)"
                    },
                    activity_2: {
                        name: "Caminata Arenal y Termales",
                        price: "$90/huésped",
                        commission: "15% comisión ($13.50)"
                    },
                    activity_3: {
                        name: "Catamarán al Atardecer",
                        price: "$85/huésped",
                        commission: "15% comisión ($12.75)"
                    }
                }
            }
        },
        features_section: {
            title: 'Más experiencias, menos complicaciones',
            subtitle: "Emanta centraliza tu operación turística para que te concentres en lo importante: tus clientes.",
            features: {
                feature_1: {
                    title: "Optimización del tiempo",
                    description: "Centraliza la gestión de itinerarios y reservas en una plataforma en tiempo real, reduciendo la carga operativa de hoteles, concierge y proveedores."
                },
                feature_2: {
                    title: "Experiencias personalizadas",
                    description: "Permite a los huéspedes reservar actividades y servicios adaptados a sus gustos, asegurando experiencias únicas y memorables."
                },
                feature_3: {
                    title: "Calidad garantizada",
                    description: "Acceso a proveedores verificados y evaluados, asegurando que cada servicio cumpla con los más altos estándares."
                },
                feature_4: {
                    title: "Incremento de ingresos y visibilidad",
                    description: "Genera oportunidades de comisiones para hoteles y mayor exposición para proveedores, impulsando reservas y ventas sin esfuerzo adicional."
                },
                feature_5: {
                    title: "Medición de satisfacción",
                    description: "Recopila retroalimentación de huéspedes y clientes para mejorar continuamente el servicio y fortalecer la fidelización."
                },
                feature_6: {
                    title: "Pagos automatizados y seguros",
                    description: "Gestiona cobros y pagos de forma automática y confiable, simplificando transacciones para todos los involucrados."
                }
            }
        },
        how_it_works: {
            title: "Cómo funciona ",
            subtitle: "Tres simples pasos para crear el itinerario perfecto",
            steps: {
                step_1: {
                    title: "Escoge el servicio que necesitas",
                    description: "Selecciona los diferentes servicios que deseas contratar de nuestra red verificada de proveedores"
                },
                step_2: {
                    title: "Reservale a tus clientes",
                    description: "Mejora la experiencia, aumenta la productividad y reduce el tiempo de espera de tus clientes al realizar itinerarios para ellos."
                },
                step_3: {
                    title: "Gana comisiones por venta",
                    description: "Gana el 100% de las comisiones por cada reserva o itinerario vendido a través de Emanta."
                }
            }
        },
        plans_section: {
            title: "Planes que se adaptan a ti",
            subtitle: "Elige el plan perfecto para tus necesidades",
            more_popular: "Más popular",
            start_free: "Comienza gratis",
            footer_note: " Puedes tener una prueba gratuita de 3 días • Sin compromiso • Cancela cuando quieras",
            monthly: "Mensual",
            yearly: "Anual",
            save_20: "Ahorra 20%",
            billed_annually: "facturado anualmente",
            plans: {
                plan_1: {
                    title: "Experience Creator",
                    description: "Ideal para creadores de experiencias y servicios.",
                    price: "2% de comisión por venta",
                    feature_1: "Sube todos los servicios que desees sin límite.",
                    feature_2: "Acceso para actualizar disponibilidad en tiempo real.",
                    feature_3: "Recibe evaluaciones y comentarios de clientes.",
                },
                plan_2: {
                    title: "Concierge",
                    description: "Optimiza la gestión de reservas y proveedores.",
                    price: "$80 + Impuestos",
                    feature_1: "Conecta con proveedores verificados.",
                    feature_2: "Obtén soporte prioritario para tus reservas.",
                    feature_3: "Gana comisiones por cada venta realizada.",
                },
                plan_3: {
                    title: "Experience creator + Concierge",
                    description: "La solución más completa para maximizar ingresos.",
                    price: "$95 + Impuestos",
                    feature_1: "Ofrece experiencias y conecta con proveedores en un solo plan.",
                    feature_2: "Duplica tus oportunidades de generar ingresos.",
                    feature_3: "Accede a funciones avanzadas de colaboración.",
                },
                plan_4: {
                    title: "Enterprise",
                    description: "Diseñado para empresas con varios concierges.",
                    price: "Custom",
                    feature_1: "Personaliza el diseño de itinerario con tu branding.",
                    feature_2: "Agrega la cantidad de usuarios que necesites.",
                    feature_3: "Selecciona los servicios más relevantes para tu organización.",
                },

            }
        },
        cta_section: {
            title: "¿Listo para transformar tu negocio?",
            subtitle: "Empieza a usar Emanta hoy mismo y lleva tu servicio al siguiente nivel.",
            button_text: "Solicitar una demo",
            without_commitment: "Sin compromiso",
            support: "Soporte 24/7",
            footer_note: " Puedes tener una prueba gratuita de 3 días  ",
            email_placeholder: "Tu email",
            sending: "Enviando...",
            success_message: "¡Gracias! Te contactaremos pronto para programar tu demo.",
            error_message: "Hubo un error al enviar tu solicitud. Por favor, inténtalo de nuevo.",
            invalid_email: "Por favor, ingresa un email válido."
        },
        chatbot: {
            title: "Asistente Emanta",
            subtitle_welcome: "Estamos aquí para ayudarte con cualquier consulta sobre la plataforma",
            subtitle_online: "En línea",
            welcome_message: "¡Hola! Soy el asistente virtual de Emanta. ¿En qué puedo ayudarte hoy?",
            input_placeholder: "Escribe tu consulta...",
            quick_actions_label: "Acciones rápidas:",
            footer_available: "Equipo disponible 24/7",
            aria_open_chat: "Abrir chat",
            aria_close_chat: "Cerrar chat",
            aria_send_message: "Enviar mensaje",
            quick_action_itinerary: "¿Cómo crear un itinerario?",
            quick_action_providers: "Gestionar proveedores",
            quick_action_commissions: "Configurar comisiones",
        },
        notifications: {
            fallback_body: "Actividad nueva en Emanta.",
            events: {
                conversation_message_created: {
                    title: "Mensaje nuevo",
                    body: "{messagePreview}",
                },
                booking_created: {
                    title: "Reserva creada",
                    body: "{serviceName} fue reservado para el itinerario {itineraryCode}.",
                },
                booking_updated: {
                    title: "Reserva actualizada",
                    body: "{serviceName} fue actualizado en el itinerario {itineraryCode}.",
                },
                booking_cancelled: {
                    title: "Reserva cancelada",
                    body: "{serviceName} fue cancelado en el itinerario {itineraryCode}.",
                },
                itinerary_approval_requested: {
                    title: "Solicitud de aprobación enviada",
                    body: "La solicitud de aprobación del itinerario {itineraryCode} fue enviada a {customerName}.",
                },
                itinerary_approved: {
                    title: "Itinerario aprobado",
                    body: "{customerName} aprobó el itinerario {itineraryCode}.",
                },
                itinerary_rejected: {
                    title: "Itinerario rechazado",
                    body: "{customerName} rechazó el itinerario {itineraryCode}.",
                },
                itinerary_payment_requested: {
                    title: "Pago solicitado",
                    body: "Se enviaron instrucciones de pago para el itinerario {itineraryCode}.",
                },
                itinerary_payment_confirmed: {
                    title: "Pago confirmado",
                    body: "Se confirmó el pago del itinerario {itineraryCode}.",
                },
                itinerary_updated_after_payment: {
                    title: "Itinerario pagado actualizado",
                    body: "Se envió una actualización del itinerario {itineraryCode}.",
                },
            },
        },
    },

}
